import { z } from 'zod'

export const ListShippingMethodsByCartIdSchema = z.object({
    cart_id: z.string().min(1),
})
